import * as React from 'react';
import styles from '../ComponentRulesEditor.module.scss';
import PanelsService from '../../../../services/panels-service';
import { FaTrashAlt } from 'react-icons/fa';
import { IRulesEntryAction } from './ComponentRulesDefinitions';

interface Props {
    panelService: PanelsService;
    action: IRulesEntryAction;
    ruleIndex: number;
    actionIndex: number;
    onChange(newAction: IRulesEntryAction, ruleIndex: number, actionIndex: number);
    onRemove(ruleIndex: number, actionIndex: number);
}

interface IRuleActionType {
    type: 'none' | 'number' | 'string' | 'substitute';
    displayName: string;
}

const ruleActionTypeMap: { [key: string]: IRuleActionType } = {
    "nothing": { type: "none", displayName: "Nothing" },
    "substitute": { type: "substitute", displayName: "Substitute Component With" },
    "remove": { type: "none", displayName: "Remove Component" },
    "minCompCount": { type: "number", displayName: "Set Minimum Component Count" },
    "setCompHeight": { type: "number", displayName: "Set Component Bounding Box Height" },
    "setCompWidth": { type: "number", displayName: "Set Component Bounding Box Width" },
    "setWrapLimit": { type: "number", displayName: "Set Repeat Wrap Limit" },
};

export const ComponentRuleAction: React.FC<Props> = ({ panelService, action, ruleIndex, actionIndex, onChange: doOnChange, onRemove }) => {
    const onChange = (key: string, value: any) => {
        let newAction: IRulesEntryAction = { ...action };
        newAction[key] = value;
        if (key === "action") {
            newAction.arg = "";
        }
        doOnChange(newAction, ruleIndex, actionIndex);
    }

    return (
        <tr>
            <td>
                <button type="button" className={`btn btn-danger ${styles.removeButton}`} onClick={() => onRemove(ruleIndex, actionIndex)}>
                    <FaTrashAlt />
                </button>
                {actionIndex == 0 ? 'Do' : 'And'}
            </td>
            <td>
                <select className="form-select" value={action.action} onChange={e => onChange("action", e.target.value)}>
                    {Object.keys(ruleActionTypeMap).map(ruleType => (
                        <option key={ruleType} value={ruleType}>{ruleActionTypeMap[ruleType].displayName}</option>
                    ))}
                </select>
            </td>
            <td>
                {
                    {
                        "none": (
                            <span></span>
                        ),
                        "number": (
                            <input type="number" className="form-control" value={action.arg} onChange={e => onChange("arg", e.target.valueAsNumber.toString())} />
                        ),
                        "string": (
                            <input type="text" className="form-control" value={action.arg} onChange={e => onChange("arg", e.target.value)} />
                        ),
                        "substitute": (() => {
                            const componentPanels = panelService.panels.filter(p => p.panelTypeID === 2);
                            let mappingsDisabled = false;
                            if (componentPanels.length === 0) {
                                componentPanels.push({
                                    ID: -1,
                                    Filename: "-- Loading --"
                                } as any);
                                mappingsDisabled = true;
                            }

                            const argValue = action.arg ?? "";

                            return (
                                <div className="input-group">
                                    <select className="form-select" value={argValue} onChange={e => onChange("arg", e.target.value)} disabled={mappingsDisabled}>
                                        {argValue.length == 0 && <option value="">- Please Select -</option>}
                                        {componentPanels.map(compPanel => (
                                            <option key={compPanel.id} value={`${compPanel.id}$${compPanel.filename}`}>{compPanel.filename}</option>
                                        ))}
                                    </select>
                                </div>
                            );
                        })()
                    }[ruleActionTypeMap[action.action].type]
                }                 
            </td>
        </tr>
    );
}
